export class BoxxImageModel {
  bytes: number; //in bytes
  dimensions: { width: number; height: number; aspectRatio: number };
  content: string;
  path: string;
  validations: {
    width: { maxWidth: number; valid: boolean };
    height: { maxHeight: number; valid: boolean };
    aspectRatio: { ratio: number; valid: boolean };
    bytes: { maxBytes: number; valid: boolean };
    valid: boolean;
  };

  constructor(data: {
    bytes: number;
    dimensions: { width: number; height: number };
    content: string;
    path: string;
  }) {
    this.bytes = data.bytes;
    this.dimensions = {
      ...data.dimensions,
      aspectRatio: data.dimensions.width / data.dimensions.height,
    };
    this.content = data.content;
    this.path = data.path;
    this.validations = {
      width: { maxWidth: 0, valid: true },
      height: { maxHeight: 0, valid: true },
      aspectRatio: { ratio: 1, valid: true },
      bytes: { maxBytes: 0, valid: true },
      valid: true,
    };
  }

  validate(constraints: BoxxImageConstraints) {
    const dimensionsValidated = this.validateDimensions(constraints);
    const bytesValidated = this.validateSize(constraints.maxBytes);

    this.validations.width = {
      maxWidth: constraints.maxWidth,
      valid: dimensionsValidated.width,
    };
    this.validations.height = {
      maxHeight: constraints.maxHeight,
      valid: dimensionsValidated.height,
    };
    this.validations.aspectRatio = {
      ratio: constraints.aspectRatio,
      valid: dimensionsValidated.aspectRatio,
    };
    this.validations.bytes = {
      maxBytes: constraints.maxBytes,
      valid: bytesValidated,
    };
    this.validations.valid =
      dimensionsValidated.width &&
      dimensionsValidated.height &&
      dimensionsValidated.aspectRatio &&
      bytesValidated;
    return this;
  }

  private validateDimensions(
    constraints: { maxWidth?: number; maxHeight?: number; aspectRatio?: number } = {
      maxWidth: 0,
      maxHeight: 0,
    }
  ) {
    return {
      width: constraints.maxWidth > 0 ? this.dimensions.width <= constraints.maxWidth : true,
      height: constraints.maxHeight > 0 ? this.dimensions.height <= constraints.maxHeight : true,
      aspectRatio: constraints.aspectRatio
        ? this.dimensions.aspectRatio - constraints.aspectRatio === 0
        : true,
    };
  }

  private validateSize(maxBytes: number) {
    return maxBytes > 0 ? this.bytes <= maxBytes : true;
  }
}

export type BoxxImageConstraints = {
  maxBytes?: number;
  maxWidth?: number;
  aspectRatio?: number;
  maxHeight?: number;
};

export type PixaBayImageConstraints = {
  hasResult?: boolean;
  url?: string;
};
